// App.js
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import Solutions from './pages/Solutions';
import Resources from './pages/Resources';
import ContactUs from './pages/ContactUs';
import './App.css';
import Navigation from './Navigation';
import Footer from './Footer';


function App() {
  return (
    <BrowserRouter>
      <section className='container-fluid bg-gradient-color fixed-header'>
        <div className='container'>
          <Navigation />
        </div>
      </section>


      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;